import Request from '@request/Request';
import { patchPromise, postPromise } from '@services/Promise';
import Group from '@models/Group';

export default class extends Request {
  constructor(ref, data) {
    data = {
      id: '',
      date: '',
      tour_id: '',
      reported_at: '',
      group_id: '',
      attendees: [],
      ...data,
    };
    super(ref, data);
  }

  async submit() {
    this.beforeSubmit();
    try {
      let data = this.data();
      let groupID = data.group_id;
      delete data.group_id;
      let url = `/groups/${groupID}/sightings`;
      let promise = postPromise;
      if (data.id) {
        url = `/groups/sightings/${data.id}`;
        promise = patchPromise;
      }
      let response = await promise(url, data);
      $showSuccess(response.message, 'group-sightings-toast');
      return response;
    } catch (error) {
      this.handleError(error);
    } finally {
      this.afterSubmit();
    }
  }
  /*
  Function to check if given species count for sighting attendee already exist
   */
  hasSpeciesSightingsData(memberID, speciesID) {
    if (!this.attendees || !this.attendees.length) {
      return false;
    }
    return this.attendees.find(
      (attendee) =>
        attendee.species_id === speciesID && attendee.member_id === memberID
    );
  }

  changeSightingsData(member, species, increment = 1) {
    let speciesSightingsData = this.hasSpeciesSightingsData(
      member.id,
      species.id
    );
    if (speciesSightingsData) {
      if (speciesSightingsData.count === 1 && increment < 1) {
        this.attendees = this.attendees.filter(
          (attendee) =>
            attendee.member_id !== member.id ||
            attendee.species_id !== species.id
        );
        return;
      }
      speciesSightingsData.count += increment;
    } else {
      if (increment < 1) {
        return;
      }
      this.attendees.push({
        member_id: member.id,
        member: member,
        species_id: species.id,
        species: species,
        count: increment,
      });
    }
  }

  getCount(memberID, speciesID) {
    let speciesSightingsData = this.hasSpeciesSightingsData(
      memberID,
      speciesID
    );
    if (speciesSightingsData) {
      return speciesSightingsData.count;
    }
    return '';
  }
}
